import React, { useState, useEffect } from 'react';
import { TabNavigator } from 'kb-web-shared';
import { themes } from 'kb-shared';
import Loader from 'components/Loader/Loader';

import * as Styled from './styles';
import * as Types from './types';
import useResourceLibrary from './hooks/use-resource-library';

import ResourcesList from './components/ResourcesList';

const TabNavigatorTheme = {
  tab: {
    selectedBG: themes.colors.night,
    deselectedBG: themes.colors.nightLight,
    selectedTitle: themes.colors.beige,
    deselectedTitle: themes.colors.gray,
    fullWidthTabs: true
  },
  content: {
    selectedBG: themes.colors.night,
    deselectedBG: themes.colors.nightLight
  }
};

const ResourcesLibrary = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const { loading, educationalContent, blogsContent, videosContent } = useResourceLibrary();

  const items: Types.ResourcesTabType[] = [
    {
      key: 'educationalContent',
      title: 'Educational Content',
      content: educationalContent
    },
    {
      key: 'blogs',
      title: 'Blogs',
      content: blogsContent
    },
    {
      key: 'videos',
      title: 'Videos',
      content: videosContent
    }
  ];

  useEffect(() => {
    if (window.analytics) {
      window.analytics.page('Resources');
    }
  }, []);

  return (
    <Styled.Container>
      <Styled.Title>Kindbody Library</Styled.Title>
      {loading ? (
        <Loader type="spin" color={themes.colors.KBYellow} height={150} width={150} />
      ) : (
        <TabNavigator
          currentIndex={tabIndex}
          getSectionTitle={(index, item) => item.title}
          getUniqueKey={(index, item) => `document-tab-nav-${item.key}`}
          items={items}
          onSelect={index => setTabIndex(index)}
          theme={TabNavigatorTheme}
          renderContent={(index, item) => <ResourcesList resourcesList={item.content} />}
        />
      )}
    </Styled.Container>
  );
};

export default ResourcesLibrary;
